import { useState } from "react";
import { Sparkles } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { PlanRecommenderDialog } from "@/components/dashboard/PlanRecommenderDialog";
import type { Situation } from "@/types/baby";

interface StageCardProps {
  stage: string | null;
  stageName: string | null;
  stageProgress: number;
  daysInStage: number;
  totalDaysInStage: number;
  situation: Situation | null;
}

export function StageCard({
  stage,
  stageName,
  stageProgress,
  daysInStage,
  totalDaysInStage,
  situation,
}: StageCardProps) {
  const [quizOpen, setQuizOpen] = useState(false);
  if (!stage || !stageName) {
    return null;
  }

  const showProgress = situation === "born" && stage !== "12m+";
  const stageLabel = stage === "prenatal" ? "Preparándote" : stage === "12m+" ? "+12 meses" : stage;

  return (
    <Card>
      <CardContent className="py-6">
        <div className="flex items-start gap-4">
          <div className="p-3 rounded-full bg-accent/50">
            <Sparkles className="h-6 w-6 text-primary" />
          </div>
          <div className="flex-1 space-y-4">
            <div>
              <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-1">
                Momento actual
              </p>
              <p className="text-2xl font-display font-medium text-foreground">
                {stageLabel}
              </p>
              <p className="text-sm text-primary font-medium mt-0.5">
                "{stageName}"
              </p>
            </div>

            {showProgress && (
              <div className="space-y-2">
                <Progress value={stageProgress} className="h-2" />
                <p className="text-xs text-muted-foreground">
                  Día {daysInStage} de {totalDaysInStage}
                </p>
              </div>
            )}

            <Button variant="outline" size="sm" className="w-full" onClick={() => setQuizOpen(true)}>
              Descubre qué necesitas
            </Button>
            <PlanRecommenderDialog open={quizOpen} onOpenChange={setQuizOpen} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
